<template>
  <div class="QueryContractItem__mc">
    <div
      :class="'QueryContractItem__mc__title' + (isOperate ? '__Operate' : '')"
    >
      <div>商品名稱</div>
      <div>商品<br />代號</div>
      <div>繳費方式</div>
      <div v-if="!isOperate">被保險人</div>
      <div>年金給付<br />年齡</div>
      <div>年金給付<br />方式</div>
      <div v-if="!isOperate">商品<br />狀態</div>
    </div>
    <!-- 主約 -->
    <div
      :class="'QueryContractItem__mc__info' + (isOperate ? '__Operate' : '')"
    >
      <div class="justify-content-start text-left">
        {{ MC.prod_name }}
      </div>
      <div>{{ MC.prod_id }}</div>
      <div>{{ getPay_freq_nm(MC.pay_freq) }}</div>
      <div v-if="!isOperate" :class="isOperate ? '' : 'd-flex flex-column'">
        <div>
          <!-- hover身分證、生日 -->
          <Tooltip v-if="familyid"
            position="top"
            :id="contractData.insured_id.indexOf('~') > -1 ? '' : contractData.insured_id"
            :birthday="formatDate(contractData.insured_birthday)"
          >
            <a
              v-on:click="routeToCustDetailHandler(contractData.insured_id)"
              class="link text-underline">
              {{ truncate(contractData.insured_name) }}
            </a>
          </Tooltip>
          <span v-else>{{ truncate(contractData.insured_name) }}</span>
        </div>
        <div class="fz_13">
          ({{ contractData.insured_gender == "1" ? "男" : "女" }},
          {{ contractData.insured_age }}歲)
        </div>
      </div>
      <div>{{ MC.dueage }}歲</div>
      <div>
        {{ MC.defaultrate || MC.duetime ? "分期給付" : "一次給付" }}
      </div>
      <div v-if="!isOperate" class="stop_sale">
        {{ MC.stop_sale == "1" ? "停售" : "" }}
      </div>
    </div>
    <!-- 附約 -->
    <!-- <div
      class="QueryContractItem__mc__SC"
      v-for="(SC, index) in MC.sc_prod_list"
      :key="'sc_' + index"
    >
      <div class="justify-content-start text-left">
        └ {{ SC.prod_name
        }}<template v-if="SC.job_cat != ''">{{
          `(職業類別:${SC.job_cat}類)`
        }}</template>
      </div>
      <div>{{ SC.prod_id }}</div>
      <div></div>
      <div class="d-flex flex-column">
        <div>{{ truncate(SC.insured_name) }}</div>
        <div class="fz_13">
          ({{ SC.insured_gender == "1" ? "男" : "女" }}, {{ SC.insured_age }}歲)
        </div>
      </div>
      <div class="justify-content-end">
        {{ formatMethods(SC.amt) }}{{ SC.amt != "" ? SC.amt_unit_nm : "" }}
      </div>
      <div class="stop_sale">{{ SC.stop_sale == "1" ? "停售" : "" }}</div>
    </div> -->
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import Tooltip from "@/desktop/components/ToolTip";
export default {
  components: { Tooltip },
  mixins: [mf_Mixin],
  props: {
    contractData: {
      type: Object,
    },
    MC: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    },
    isOperate: {
      type: Boolean,
      default: false,
    },
    familyid: {
      type: String,
      default: '',
    },
    routeToCustDetailWithCustomStatusCheck: {
      type: Function,
      default: null,
    },
  },
  methods: {
    routeToCustDetailHandler(custId) {
      if (this.routeToCustDetailWithCustomStatusCheck) {
        this.routeToCustDetailWithCustomStatusCheck(custId);
        return;
      }
      this.routeToCustDetail(custId);
    },
  },
};
</script>

<style lang="scss" scoped>
.QueryContractItem {
  &__mc {
    &__index {
      padding: 15px;
      line-height: 1.38;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
      color: #2f2fc7;
      background-color: rgba(160, 160, 240, 0.1);
      border-top: solid 1px rgba(194, 196, 199, 0.8);
    }
    &__title {
      width: 100%;
      display: flex;
      font-weight: 700;
      color: #2f2fc7;
      background-color: rgba(160, 160, 240, 0.1);
      border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 6%;
      }
      & > div:nth-of-type(3) {
        width: 15%;
      }
      & > div:nth-of-type(4) {
        width: 11%;
      }
      & > div:nth-of-type(5) {
        width: 12%;
      }
      & > div:nth-of-type(6) {
        width: 12%;
      }
      & > div:nth-of-type(7) {
        width: 6%;
        &.stop_sale {
          color: #000;
          font-weight: 700;
        }
      }
    }
    &__title__Operate {
      width: 100%;
      display: flex;
      font-weight: 700;
      color: #2f2fc7;
      background-color: rgba(160, 160, 240, 0.1);
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 12%;
      }
      & > div:nth-of-type(3) {
        width: 15%;
      }
      & > div:nth-of-type(4) {
        width: 17%;
      }
      & > div:nth-of-type(5) {
        width: 18%;
      }
    }
    //主約
    &__info {
      width: 100%;
      display: flex;
      color: #323a45;
      background-color: #fff;
      border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 6%;
      }
      & > div:nth-of-type(3) {
        width: 15%;
      }
      & > div:nth-of-type(4) {
        width: 11%;
      }
      & > div:nth-of-type(5) {
        width: 12%;
      }
      & > div:nth-of-type(6) {
        width: 12%;
      }
      & > div:nth-of-type(7) {
        width: 6%;
        &.stop_sale {
          color: #000;
          font-weight: 700;
        }
      }
    }
    //Operate主約
    &__info__Operate {
      width: 100%;
      display: flex;
      color: #323a45;
      background-color: #fff;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 12%;
      }
      & > div:nth-of-type(3) {
        width: 15%;
      }
      & > div:nth-of-type(4) {
        width: 17%;
      }
      & > div:nth-of-type(5) {
        width: 18%;
      }
    }
    //   附約
    &__SC {
      width: 100%;
      display: flex;
      color: #323a45;
      background-color: #f5f5f5;
      border-top: solid 1px rgba(194, 196, 199, 0.8);
      & > div {
        border: solid 1px rgba(194, 196, 199, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 3px 7px;
      }
      & > div:nth-of-type(1) {
        min-height: 50px;
        width: 38%;
      }
      & > div:nth-of-type(2) {
        width: 6%;
      }
      & > div:nth-of-type(3) {
        width: 15%;
      }
      & > div:nth-of-type(4) {
        width: 11%;
      }
      & > div:nth-of-type(5) {
        width: 12%;
      }
      & > div:nth-of-type(6) {
        width: 12%;
      }
      & > div:nth-of-type(7) {
        width: 6%;
        &.stop_sale {
          color: #000;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
